/* eslint-disable react/no-danger */
import React, { Component, PropTypes } from 'react';
import CSSModules from 'react-css-modules';
import styles from './Resume.css';
import content from '../../text/resume.md';
import FullWidthRegion from '../components/FullWidthRegion';

class Resume extends Component {
  static propTypes = {
    styles: PropTypes.objectOf(PropTypes.string),
  };

  componentDidMount() {
    document.title = 'Jennifer Zwick‘s Resume';
  }

  render() {
    const contentWithStyles = content.replace(/<h2/g, `<h2 class="${this.props.styles['section-title']}"`);

    return (
      <FullWidthRegion>
        <h2 styleName="page-title">Resume</h2>

        <div
          styleName="resume"
          dangerouslySetInnerHTML={{ __html: contentWithStyles }}
        />
      </FullWidthRegion>
    );
  }
}

export default CSSModules(Resume, styles, { errorWhenNotFound: false });



// WEBPACK FOOTER //
// ./application/js/pages/Resume.js